<template>
  <VContainer fluid>
    <VCard class="elevation-0" color="transparent">
      <div class="d-flex justify-space-between align-start">
        <!-- Foto principal (quadrada) -->
        <VAvatar
          class="ma-3"
          :size="200"
          rounded="0"
          :image="Photo"
        />

        <div class="flex-grow-1">
          <VCardTitle
            class="text-h5 text-start font-weight-bold wrap-title"
          >
            <RouterLink
              :to="`/${$i18n.locale}/article/${ID}`"
              class="text-decoration-none"
            >
              <span style="color: black; text-decoration: underline;">{{ Title }}</span>
            </RouterLink>
          </VCardTitle>

          <VCardSubtitle class="text-start">
            {{ DataArticle }}
          </VCardSubtitle>

          <VCardActions class="pt-4">
            <VAvatar :size="40">
              <VImg :src="AutorPhoto" alt="Author" />
            </VAvatar>

            <VRow class="ml-2" no-gutters>
              <VCol cols="12">
                <span class="font-weight-bold text-primary">{{ Author }}</span>
                <VBtn
                  v-if="Linkedin"
                  icon
                  variant="text"
                  class="social-btn ml-n1"
                  :href="Linkedin"
                  target="_blank"
                  rel="noopener"
                  aria-label="LinkedIn"
                >
                  <VIcon icon="mdi-linkedin" />
                </VBtn>
              </VCol>
            </VRow>
          </VCardActions>
        </div>
      </div>
    </VCard>
  </VContainer>
</template>

<script>
export default {
  name: 'ArticleListItem',
  props: {
    ID: { type: String, required: true },
    DataArticle: { type: String, required: true },
    Title: { type: String, required: true },
    Author: { type: String, required: true },
    Photo: { type: String, required: true },       // imagem grande
    AutorPhoto: { type: String, required: true },  // avatar do autor (mantive o nome original)
    Linkedin: { type: String, default: null }
  },
  methods: {
    openSocialNetwork (social, link) {
      if (social === 'linkedin' && link) window.open(link, '_blank')
    }
  }
}
</script>

<style>
.wrap-title{
  white-space: normal !important;   /* permite múltiplas linhas */
  word-break: break-word;           /* quebra palavras longas se precisar */
  overflow-wrap: anywhere;          /* fallback extra para strings sem espaços */
}

.gb-social-button__focuser{
  border: none !important;
}
.text-decoration-none { text-decoration: none; }
</style>
